import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { Align, Button, HeaderBar, ModernSearch, Spacer, withMobile } from 'component-library-next'

import Loader from '@app/common/Components/Loader'
import { IModernSearchItem } from '@app/common/helpers/IModernSearchItem'
import {
  IHandleEmailTemplateChange,
  ISelectedEmailTemplate
} from '@app/modules/Messages/Components/AnswerArea/AnswerArea'
import { EmailTemplatePreview } from '@app/modules/Messages/Components/EmailTemplatePreview/EmailTemplatePreview'
import AddDocuments from '@app/modules/Messages/Components/LawyerAnswer/AddDocuments'
import ChatDocuments from '@app/modules/Messages/Components/LawyerAnswer/AddDocuments/chatDocuments'
import TextArea from '@app/modules/Messages/Components/TextArea/TextArea'
import { useCustomerId } from '@app/modules/Messages/hooks/useCustomerId'
import LawyerChatAction from '@app/modules/Messages/store/actions'
import { Message } from '@app/queries/CustomerAsLawyer/models'

import './styles.scss'

const Documents = ChatDocuments(AddDocuments)

type Props = {
  lastQuestion: Message
  mobile: boolean
  latestPurchase: string
  emailTemplates?: IModernSearchItem[]
  selectedEmailTemplate?: ISelectedEmailTemplate
  setSelectedEmailTemplate?: React.Dispatch<React.SetStateAction<ISelectedEmailTemplate | null>>
  handleEmailTemplateChange?: (props: IHandleEmailTemplateChange) => void
}

const getLawyerChatState = ({ lawyerChat }: any) => ({ ...lawyerChat })

export const InformationMessageArea = withMobile(
  ({
    lastQuestion,
    mobile,
    latestPurchase,
    emailTemplates,
    selectedEmailTemplate,
    setSelectedEmailTemplate,
    handleEmailTemplateChange
  }: Props) => {
    const { sending } = useSelector(getLawyerChatState)
    const [textAreaValue, setTextAreaValue] = useState<string>()
    const [showTextAreaError, setShowTextAreaError] = useState<boolean>(false)
    const customerId = useCustomerId()

    const dispatch = useDispatch()

    const sendForm = useCallback(() => {
      if (!textAreaValue || textAreaValue.length < 1) {
        setShowTextAreaError(true)
        return
      } else {
        setShowTextAreaError(false)
      }
      dispatch(
        LawyerChatAction.lawyerAnswer({
          data: { message: textAreaValue },
          latestMessageId: lastQuestion.id,
          isInformation: true,
          templateId: selectedEmailTemplate?.id,
          customerId
        })
      )
      dispatch(LawyerChatAction.clearSelectedDocs())
      setTextAreaValue('')
      typeof setSelectedEmailTemplate === 'function' && setSelectedEmailTemplate(null)
    }, [textAreaValue, selectedEmailTemplate])

    useEffect(() => {
      dispatch(LawyerChatAction.clearSelectedDocs())
    }, [])

    return (
      <div className={'information-message'}>
        <HeaderBar title={'Schriftverkehr & Informationen an Mandanten senden'} />
        <Spacer />
        <TextArea
          className='add-lawyer-documents__textarea'
          value={textAreaValue}
          placeholder='Nachricht an Mandanten eingeben'
          maxLength={20000}
          onChange={(notes) => setTextAreaValue(notes)}
          isControlled
        />

        {showTextAreaError && (
          <div className='document-error'>Bitte füllen Sie dieses Feld aus</div>
        )}
        {latestPurchase !== 'advocard-ai-checks' && (
          <>
            <section>
              <h3>Vorlage für Vermieter anschreiben hinzufügen</h3>
              <ModernSearch
                placeholder='Vorlage auswählen'
                noOptionsMessage='Vorlage auswählen'
                groupedOptions={emailTemplates || []}
                onChange={handleEmailTemplateChange}
              />
              <Spacer />
            </section>

            {selectedEmailTemplate && (
              <EmailTemplatePreview
                emailTemplate={selectedEmailTemplate}
                onClose={() => {
                  typeof setSelectedEmailTemplate === 'function' && setSelectedEmailTemplate(null)
                }}
              />
            )}
          </>
        )}
        <Spacer />
        <Documents />
        {sending && <Loader />}
        {mobile && <Spacer />}
        <Align direction={Align.directions.flexEnd}>
          <Button disabled={sending} size={Button.sizes.medium} onClick={sendForm}>
            information senden
          </Button>
        </Align>
      </div>
    )
  }
)
